export const COOKIE_ORDER_CONTACT_STEP = '_ORDER_CONTACT_STEP';
